import { useApiMutation } from '@/hooks/use-api-mutation.hook';
import { useApiQuery } from '@/hooks/use-api-query.hook';
import { ApiMethods, Routes } from '@/utils/constants';
import { CacheKeys } from '@/utils/constants/cache-validation-keys';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { ApiResponseType } from '../api-response.type';
import { MyProfileResponseType } from '../auth/types/my-profile.type';
import { QuizAttemptType } from './types/quiz.type';

export function useGetAllParentChildren(isEnabled: boolean = true) {
  return useApiQuery<ApiResponseType<MyProfileResponseType[]>>(
    [CacheKeys.PARENT_CHILD],
    `/user/children/list`,
    { onSuccess: () => {} },
    isEnabled,
  );
}

export function useGetQuizAttempt(quizAttemptId?: string) {
  return useApiQuery<ApiResponseType<QuizAttemptType>>(
    [CacheKeys.QUIZ_ATTEMPT, `${CacheKeys.QUIZ_ATTEMPT}-${quizAttemptId}`],
    `/quiz_attempts_parent/${quizAttemptId}`,
    {
      onSuccess: () => {},
    },
    !!quizAttemptId,
  );
}

export function useGradeQuizAttempt(quizAttemptId: string) {
  const navigate = useNavigate();

  return useApiMutation<{ grades: boolean[] }, ApiResponseType<undefined>>(
    `/quiz_attempts_parent/${quizAttemptId}/grade`,
    ApiMethods.POST,
    [CacheKeys.QUIZ_ATTEMPT, `${CacheKeys.QUIZ_ATTEMPT}-${quizAttemptId}`],
    {
      onSuccess: () => {
        toast.success('Quiz graded successfully');
        // navigate(Routes.realChildren);
      },
      onError: () => {
        toast.success('Quiz graded successfully');
        navigate(Routes.realChildren);
      },
    },
  );
}
